// Khai báo tên key LocalStorage, SessionStorage sử dụng trong hệ thống
export default {
  Local: {
    Context: 'emis_enrollment_portal_vuex',
    Token: 'Token',
  },

  Session: {

  },
}
